module.exports = __webpack_public_path__ + "assets/img/default-empty-state.6acbf835.svg";